import { render, staticRenderFns } from "./LegalNotesPage.vue?vue&type=template&id=daca9092&"
import script from "./LegalNotesPage.vue?vue&type=script&lang=js&"
export * from "./LegalNotesPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports